<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 17:54:29
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-18 17:08:23
-->
<template>
  <div class="index-video wh100 posrel">
    <video v-show="canplay" ref="indexVideo" autoplay muted loop :src="require('@/assets/video/index.mp4')" />
    <div v-show="!canplay" class="loader">
      <div class="inner one"></div>
      <div class="inner two"></div>
      <div class="inner three"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canplay: false // 准备状态
    }
  },
  mounted () {
    this.$refs.indexVideo.oncanplay = () => {
      this.canplay = true
    }
  }
}
</script>

<style lang="less" scoped>
.index-video {
  background: #000000;
  video{
    height: 100vh;
    width: 100%;
    object-fit: fill;
  }
  .loader {
    position: absolute;
    top: calc(50% - 32PX);
    left: calc(50% - 32PX);
    width: 64PX;
    height: 64PX;
    border-radius: 50%;
    perspective: 800PX;
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .inner.one {
    left: 0%;
    top: 0%;
    animation: rotate-one 1s linear infinite;
    border-bottom: 3PX solid #EFEFFA;
  }

  .inner.two {
    right: 0%;
    top: 0%;
    animation: rotate-two 1s linear infinite;
    border-right: 3PX solid #EFEFFA;
  }

  .inner.three {
    right: 0%;
    bottom: 0%;
    animation: rotate-three 1s linear infinite;
    border-top: 3PX solid #EFEFFA;
  }

  @keyframes rotate-one {
    0% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-two {
    0% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-three {
    0% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
    }
  }
}
</style>
